'use strict';

// Category relation arrays have no intrinsic public priority. Pick a stable slug
// so API result order, eager-loading order and card rendering cannot change SEO URLs.
function publicListingCategory(listing) {
  const categories = (listing?.listingCategories || [])
    .filter(row => !listing.tenantId || !row?.tenantCategory?.tenantId || row.tenantCategory.tenantId === listing.tenantId)
    .map(row => ({ ...row?.tenantCategory, slug: String(row?.tenantCategory?.slug || '').trim() }))
    .filter(row => row.slug)
    .sort((a, b) => a.slug < b.slug ? -1 : a.slug > b.slug ? 1 : 0);
  return categories[0];
}
function publicListingPath(listing) {
  const slug = String(listing?.slug || '').trim();
  if (!slug) return '/listings';
  const category = publicListingCategory(listing);
  return `/listings/${category ? `${encodeURIComponent(category.slug)}/` : ''}${encodeURIComponent(slug)}`;
}

module.exports = { publicListingPath, publicListingCategory };
